import geoutils from './helper/geo'
import { ShapeMaker, TransformContext } from './types'

export type LineStringOptions = {
  coords: number[][]
  stroke?: string
  width?: number
  simplify?: boolean
}

export default class LineStringMaker implements ShapeMaker {
  coords: number[][]
  stroke?: string
  width?: number
  simplify?: boolean

  constructor(options: LineStringOptions) {
    this.coords = options.coords
    this.stroke = options.stroke
    this.width = Number.isFinite(options.width) ? Number(options.width) : 3
    this.simplify = options.simplify || false
  }

  /**
   * calculate the coordinates of the envelope / bounding box: (min_lon, min_lat, max_lon, max_lat)
   */
  extent() {
    const allPoints = this.coords

    const longitudes = allPoints.map(c => c[0])
    const latitudes = allPoints.map(c => c[1])

    return [
      Math.min(...longitudes),
      Math.min(...latitudes),
      Math.max(...longitudes),
      Math.max(...latitudes),
    ] as [number, number, number, number]
  }

  static toSVG(shape: LineStringMaker, context: TransformContext) {
    const points = shape.coords.map(coord => [
      context.xToPx(geoutils.lonToX(coord[0], context.zoom)),
      context.yToPx(geoutils.latToY(coord[1], context.zoom)),
    ])

    const startPoint = points.shift()

    if (!startPoint) return ''

    const pathParts = [
      `M ${startPoint[0]} ${startPoint[1]}`,
      ...points.map(p => `L ${p[0]} ${p[1]}`),
      'Z',
    ]

    return `<path
    d="${pathParts.join(' ')}"
    stroke="${shape.stroke || '#000000'}"
    stroke-width="${shape.width}"/>`
  }

  toSVG(context: TransformContext) {
    return LineStringMaker.toSVG(this, context)
  }
}
